<template>
  <div>
    <div class="menu" v-if="isShow">
      <router-link to="/">
        <div class="home"></div>
        <div>{{$t('mall.Home')}}</div>
      </router-link>
      <router-link to="/order/all/list">
        <div class="stroke"></div>
        <div>{{$t('mall.Stroke')}}</div>
      </router-link>
      <router-link to="/user/main">
        <div class="user"></div>
        <div>{{$t('mall.Me')}}</div>
      </router-link>
    </div>
    <div class="menu" v-else>
      <a :href="origin+'/'">
        <div class="home"></div>
        <div>{{$t('mall.Home')}}</div>
      </a>
      <a :href="origin+'/order/list'">
        <div class="stroke"></div>
        <div>{{$t('mall.Stroke')}}</div>
      </a>
      <router-link to="/user/main">
        <div class="user"></div>
        <div>{{$t('mall.Me')}}</div>
      </router-link>
    </div>
  </div>
</template>
<style scoped>
  .home {
    background-image: url('/static/img/home.png');
    background-repeat: no-repeat;
    width: 0.798rem;
    height: 0.798rem;
    background-size:  100% 100%;
    margin: 0 auto;
  }

  .router-link-exact-active .home {
    background-image: url('/static/img/home1.png');
    background-repeat: no-repeat;
    width: 0.798rem;
    height: 0.798rem;
    background-size: 100% 100%;
    margin: 0 auto;
  }

  .stroke {
    background-image: url('/static/img/stroke.png');
    background-repeat: no-repeat;
    width: 0.798rem;
    height: 0.798rem;
    background-size: 100% 100%;
    margin: 0 auto;
  }

  .router-link-exact-active .stroke {
    background-image: url('/static/img/stroke1.png');
    background-repeat: no-repeat;
    width: 0.798rem;
    height: 0.798rem;
    background-size: 100% 100%;
    margin: 0 auto;
  }

  .user {
    background-image: url('/static/img/user.png');
    background-repeat: no-repeat;
    width: 0.798rem;
    height: 0.798rem;
    background-size:  100% 100%;
    margin: 0 auto;
  }

  .router-link-exact-active .user {
    background-image: url('/static/img/user1.png');
    background-repeat: no-repeat;
    width: 0.798rem;
    height: 0.798rem;
    background-size:  100% 100%;
    margin: 0 auto;
  }

  a {
    text-align: center;
    flex: 3;
    text-decoration: none;
    color: #666;
  }

  .menu .router-link-exact-active {
    color: #12a3ff
  }

  .menu {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 1.489rem;
    font-size: 0.3192rem;
    box-shadow: 1px 0px 3px #e7e7e7;
    background: #fff;
    border-top: 0.01rem solid #e7e7e7;
    box-sizing: border-box;
  }

  .menu a:active {
    text-decoration: none;
  }

</style>
<script>
  export default {
    props:["systemVersion", "origin"],
    computed: {
      isShow() {
        return this.systemVersion != "newApp"?true:false
      }
    },
    data() {return {}},
  }
</script>
